import styled from 'styled-components';
import { palette } from '../styles';

export const ApplicationsContainer = styled.section`
  width: 88%;
  padding: 0px 24px;
  margin: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-family: 'Sofia Pro', sans-serif;
  align-items: center;
  @media screen and (max-width: 1366px) {
    width: auto;
    padding: 0 0 0 48px;
  }
  .heading {
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    padding: 32px 16px 64px 16px;
    width: 100%;
    label {
      color: ${palette.white};
      margin-right: 10px;
      font-size: 1rem;
    }
    input {
      padding: 10px 5px;
      font-size: 1rem;
      width: 400px;
      color: ${palette.white};
      background-color: transparent;
      border: none;
      border-bottom: 1px solid ${palette.white};
    }
  }
  .headingFilters {
    display: flex;
    justify-content: space-between;
    padding: 0px 16px;
    select {
      padding: 10px 5px;
    }
    button {
      background-color: transparent;
      cursor: pointer;
      border: none;
    }
    .k-button {
      cursor: pointer;
      background: transparent;
      &:focus {
        outline: none;
      }
      &:hover {
        //rgba(156,156,156,0.6)
        background: ${palette.lightgray};
        cursor: pointer;
      }
    }
  }
  h1 {
    font-family: 'Cooper Md BT', serif;
    margin: 32px 16px;
    font-size: 32px;
    color: #fff;
  }
  h2 {
    font-family: 'Cooper Md BT', serif;
    margin: 32px 16px;
    font-size: 20px;
    color: #0f3f44;
  }
  .MuiTableContainer-root {
    overflow-x: inherit;
    padding: 16px;
  }
  .MuiTableHead-root {
    background-color: #f5f5f5;
    color: #0f3f44;
    border-radius: 8px;
  }
  .MuiTableCell-head {
    color: #fff;
    font-family: 'Cooper Md BT', serif;
    font-size: 16px;
    color: #0f3f44;
  }
  .loading {
    display: table;
    margin: 32px auto;
  }
`;

export default null;
